import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'keepHtml',
    standalone: false
})
export class KeepHtmlPipe implements PipeTransform {
  constructor(readonly sanitizer: DomSanitizer) {
  }
  
  transform(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

}
